var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8296 67.6474C55.7283 60.4718 66.9968 55.7413 72.635 53.4557C88.7332 46.9299 92.0782 45.7963 94.2585 45.7581C94.738 45.7507 95.8102 45.8665 96.5047 46.4157C97.0912 46.8795 97.2526 47.506 97.3298 47.9457C97.4069 48.3854 97.5031 49.3871 97.4267 50.1698C96.5543 59.103 92.7796 80.7818 90.8592 90.7872C90.0467 95.0209 88.4467 96.4404 86.8976 96.5794C83.5314 96.8813 80.9752 94.4111 77.7148 92.3282C72.6129 89.0687 69.7307 87.0397 64.7784 83.8591C59.0552 80.1834 62.7654 78.1632 66.027 74.8615C66.8805 73.9975 81.7124 60.8492 81.9995 59.6565C82.0354 59.5073 82.0688 58.9513 81.7297 58.6576C81.3908 58.364 80.8906 58.4644 80.5296 58.5442C80.0179 58.6575 71.8675 63.9078 56.0786 74.2952C53.7651 75.8434 51.6697 76.5977 49.7922 76.5582C47.7224 76.5146 43.7411 75.4176 40.7814 74.48C37.1512 73.33 34.266 72.7219 34.5172 70.7687C34.6481 69.7513 36.0855 68.711 38.8296 67.6474Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.e45cb70e8808b20425277c1a9db9d148.svg";
export { ForwardRef as ReactComponent };